import { Button, Dialog, DialogContent, DialogTitle, Grid, Typography, useTheme } from '@mui/material';
import { CloseSharp } from '@mui/icons-material';
import FullscreenLogoLoader from '../../Components/FullScreenLoader'
import React, { useEffect, useState,useContext } from 'react'
import { Il8nContext } from '../../Helper/i18n';


export default function LivePhotoUpload(props) {
    const theme = useTheme();
    const [livePhotoImage, setLivePhotoImage] = useState()
    const [error, setError] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const localeText = useContext(Il8nContext)
    let streamNavigator = undefined;

    useEffect(() => {
        if(props.openLivePhotoDialog){
            setTimeout( getVideoStream, 100)
        }
        else{
            setLivePhotoImage()
        }
        return ()=>{
            return streamNavigator?.getTracks().forEach(track=> track.stop())
        }
    }, [props])

    const getVideoStream = async ()=>{
        setError()
        setIsLoading(true)
        navigator.mediaDevices.getUserMedia({video: true, audio: false})
        .then(stream=> {
            setIsLoading(false)
            let video = document.getElementById("livePhoto");
            streamNavigator = stream;
            video.srcObject = stream;
            video.autoplay = true;
        })
        .catch(error => {
            setIsLoading(false)
            switch(error.code){
                case 0 : 
                    setError(
                        <>
                            <label>{localeText?.livePhotoUploadAllowPermission}</label>
                            <i style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }} onClick={() => window.open("https://www.google.com/search?q=allow+browser+to+access+camera", "_blank")} >{localeText?.livePhotoCamera}</i>
                            <label>{localeText?.livePhotofromBrowserSettings}</label> 
                        </>
                    )
                    break;
                case 8 : 
                    setError(localeText?.livePhotoDeviceNotFound)
                    break;
            }
        });
    }

    const captureImage = () => {
        let video = document.getElementById("livePhoto");
        let canvas = document.getElementById("livePhotoCanvas");
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
        let canvasImage = canvas.toDataURL('image/jpeg');
        setLivePhotoImage(canvasImage);
    }

    const savePhoto = () => { 
        props.handleLivePhotoDialog(); 
        props.setImgArray && props.setImgArray([...(props.imgArray ? props.imgArray : []), livePhotoImage])
        props.handleLivePhotoCapture([...(props.imgArray ? props.imgArray : []), livePhotoImage], props.docId, props.count, props.docName, props.mappingKey); 
    }

    return (
        <div>
            <Dialog
                open={props.openLivePhotoDialog}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        props.handleLivePhotoDialog();
                    }
                }}
                fullScreen
                disableEscapeKeyDown
            >
                <DialogTitle style={{ background: theme.palette.common.neutral }}>
                    <Typography display="inline" style={{ color: "white" }}>{"Capture Photo"}</Typography>
                    <CloseSharp style={{ float: "right", color: "white" }} onClick={e => props.handleLivePhotoDialog()}></CloseSharp>
                </DialogTitle>
                <DialogContent>
                    {isLoading && <FullscreenLogoLoader />}
                    <Grid container spacing={4} justifyContent="center" alignItems="center" style={{paddingTop:"25px"}}>
                        {error && <Grid item xs={12} >
                            <Typography variant="h5" color="error" style={{marginLeft:"25px"}}>
                                {error}
                            </Typography>
                        </Grid>}
                        <Grid item container spacing={4} xs={6} justifyContent="center" alignItems="center">
                            <Grid item xs={12} style={{border:"1px solid black"}}>
                                <video id="livePhoto" style={{height:"100%", width:"100%"}} autoplay></video>
                            </Grid>
                            <Grid item xs={12}>
                                <Button disabled={error} id="camera_button" onClick={captureImage} variant={"outlined"} color="primary" style={{display:"flex", margin:"auto"}}>
                                    {(livePhotoImage ? "Re-capture " : "Capture ") + "Photo"}
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item container spacing={4} xs={6} justifyContent="center" alignItems="center" style={!livePhotoImage ? { display: "none" } : {}}>
                            <Grid item xs={12} style={{border:"1px solid black"}}>
                                <canvas id="livePhotoCanvas" style={{height: "100%", width:"100%"}}/>
                            </Grid>
                            <Grid item xs={12} /* style={!livePhotoImage ? { display: "none" } : {}} */>
                                <Button /* disabled={!livePhotoImage} */ onClick={savePhoto} color="primary" variant="contained" style={{display:"flex", margin:"auto"}}>
                                    {localeText?.livePhotoSavePhoto}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </div>
    )
}
